import React, { CSSProperties } from "react";
import pauseIcon from "./assets/pause-icon.svg";
import playIcon from "./assets/play-icon.svg";
import nextIcon from "./assets/right-arrow.svg";
import { IMediaItem, IMediaList } from "../store/types";
interface IProps {
  playing: boolean;
  list: IMediaList;
  current: IMediaItem;
  onPlayClick();
  onPauseClick();
  onNextClick();
  onPrevClick();
}

function Contols({
  playing = false,
  onPlayClick,
  onPauseClick,
  onNextClick,
  onPrevClick,
  list,
  current,
}: IProps) {
  function renderPlayBtn() {
    return (
      <button onClickCapture={onPlayClick}>
        <img className="player-play-icon" src={playIcon} alt="" />
      </button>
    );
  }
  function renderPauseBtn() {
    return (
      <button onClickCapture={onPauseClick}>
        <img className="player-pause-icon" src={pauseIcon} alt="" />
      </button>
    );
  }
  function renderNextBtn() {
    const length = list.length;
    const currentIndex = current?.idx ?? 1;
    const condition = currentIndex >= 0 && length > currentIndex + 1;
    const style: CSSProperties = {
      opacity: condition ? 1 : 0,
      pointerEvents: length > currentIndex ? "all" : "none",
    };
    return (
      <button style={style} onClick={onNextClick}>
        <img className="player-next-icon" src={nextIcon} alt="" />
      </button>
    );
  }
  function renderPrevBtn() {
    const length = list.length;
    const currentIndex = current?.idx ?? 1;
    const condition = length > 1 && currentIndex > 0;
    const style: CSSProperties = {
      opacity: condition ? 1 : 0,
      pointerEvents: condition ? "all" : "none",
    };
    return (
      <button style={style} onClick={onPrevClick}>
        <img className="player-prev-icon" src={nextIcon} alt="" />
      </button>
    );
  }
  return (
    <div className="controls">
      {renderPrevBtn()}
      {playing ? renderPauseBtn() : renderPlayBtn()}
      {renderNextBtn()}
    </div>
  );
}

export default Contols;
